import { APIRequestDtoImpl, APIRequest } from '../../apiRequest';
import { GetBannerDto } from '../../../dto/getbannerdetails/getbannerdto';

export interface GetBannerDetailsRequest extends APIRequest
{
    getGetBannerRequest(): GetBannerDto;
}

export class GetBannerDetailsRequestImpl extends APIRequestDtoImpl implements GetBannerDetailsRequest
{
    constructor(private getBannerData: GetBannerDto)
    {
        super();
    }

    getGetBannerRequest(): GetBannerDto
    {
        return this.getBannerData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getbannerdetails/getbannerdetailsrequest.tsx